export const wait = (mills = 1000) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, mills);
  });
}